/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CommentEntity {
  CONTRACT = 'contract',
  PROFESSIONAL = 'professional',
}
